import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'crypto-forgot-password-message',
  templateUrl: './forgot-password-message-crypto.component.html',
  styleUrls: [ './forgot-password-message-crypto.component.scss' ],
})
export class ForgotPasswordMessageCryptoComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages-crypto/components-crypto/forgot-password-message-crypto/forgot-password-message-crypto.component.ts